import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { ForeignClassTrip } from './foreignClassTrips';

dayjs.extend(isoWeek);

/** Eine fremde Klassenfahrt, fertig positioniert für eine Board-Zeile. */
export type ForeignTripCard = {
  key: string;
  from: Date;
  to: Date;
  durationInDays: number;
  subjectShort: string;
  classesShort: string;
  tooltip: string;
};

export type ForeignTripIndex = Map<string, ForeignTripCard[]>;

/**
 * Schlüssel exakt wie in GridWeek (`${row.value}:${weekNumber}:${year}`), damit dort ein
 * einzelnes `Map.get()` genügt und pro Tageszelle keine Arbeit anfällt.
 */
export function foreignTripIndexKey(rowValue: string, weekNumber: number, year: number): string {
  return `${rowValue}:${weekNumber}:${year}`;
}

/**
 * Baut den Index einmalig beim Store-Aufbau.
 *
 * Eine Fahrt landet nur in ihrer **Startwoche** und läuft von dort nach rechts über — genauso
 * wie eine echte Karte. Je Holder entsteht ein eigener Eintrag, weil dieselbe Fahrt in der
 * Klassen-, Lehrer- und Raumzeile erscheint.
 */
export function buildForeignTripIndex(trips: ForeignClassTrip[]): ForeignTripIndex {
  const index: ForeignTripIndex = new Map();

  trips.forEach((trip, tripIndex) => {
    const start = dayjs(trip.from);
    const durationInDays = dayjs(trip.to).startOf('day').diff(start.startOf('day'), 'day') + 1;
    const weekNumber = start.isoWeek();
    const year = start.isoWeekYear();

    trip.holders.forEach((holder) => {
      const key = foreignTripIndexKey(holder.uuid, weekNumber, year);
      const card: ForeignTripCard = {
        key: `${tripIndex}:${holder.uuid}`,
        from: trip.from,
        to: trip.to,
        durationInDays,
        subjectShort: trip.subjectShort,
        classesShort: trip.classesShort,
        tooltip: trip.tooltip,
      };
      const existing = index.get(key);
      if (existing) {
        existing.push(card);
      } else {
        index.set(key, [card]);
      }
    });
  });

  return index;
}
